import { getCurrentDate } from '../abstract/time';
import Sha1 from './sha';
import Swal from 'sweetalert2';
import { translate } from '../globals/translations';

import imageCompression from 'browser-image-compression';

// Image Compression settings. See https://github.com/Donaldcwl/browser-image-compression#api for options.
const img_compression_settings = {
    maxSizeMB: 0.4, // 400kb
};

/**
 * Submit a road photo to the api
 *
 * @returns boolean
 */
function submitRoadPhoto(photos, road, callback_data = null, callback = null) {
    const base_url = getBaseApiUrl();
    const api_url = `${base_url}/road/${road.body.road_id}`;
    const form_data = new FormData();

    compressImages(photos)
        .then((photos) => {
            for (let i = 0; i < photos.length; i++) {
                form_data.append('photos[]', photos[i], photos[i].name);
            }

            form_data.append('key', getApiKey());

            $.ajax({
                method: 'POST',
                url: api_url,
                data: form_data,
                crossDomain: true,
                processData: false,
                contentType: false,
            })
                .done((res) => {
                    Swal.close();

                    setTimeout(function () {
                        if (res.status == 200 && res.body) {
                            let swalTitle = translate('success');
                            let swalMessage = translate('info_submitted');

                            Swal.fire({
                                icon: 'success',
                                title: swalTitle,
                                text: swalMessage,
                                button: false,
                                showCloseButton: true,
                                showConfirmButton: false,
                            });

                            if (callback != null) {
                                callback(road, callback_data);
                            }
                        }
                    }, 200);
                })
                .fail((xhr, status, error) => {
                    Swal.close();

                    console.error('AJAX call failed:', status, error);
                    console.error('Response:', xhr.responseText);

                    Swal.fire({
                        icon: 'error',
                        title: 'Submission Failed',
                        text: `There was an issue submitting the photo: ${xhr.status} ${xhr.statusText}. Please try again.`,
                    });
                });
        })
        .catch((error) => {
            console.error('Image compression error:', error);

            Swal.fire({
                icon: 'error',
                title: 'Image Compression Failed',
                text: 'There was an issue compressing the images. Please try again.',
            });
        });
}

function compressImages(images) {
    return new Promise((resolve, reject) => {
        let maxFileSize = 400;

        let compressionPromises = [...images].map((img) => {
            // Do not compress multiple times.
            if (getSizeKB(img) < maxFileSize) {
                return img;
            }

            return imageCompression(img, img_compression_settings)
                .then((compressedFile) => {
                    return compressedFile;
                })
                .catch((error) => {
                    return img;
                });
        });

        // Set new state with compressed images.
        Promise.all(compressionPromises)
            .then((cImages) => {
                images = cImages;
            })
            .then(() => {
                resolve(images);
            });
    });
}

function getSizeKB(img) {
    return img.size / 1024;
}

/**
 * Helper function to grab the base API url
 *
 * @returns string
 */
function getBaseApiUrl() {
    return window.location.protocol + '//' + window.location.host + '/api';
}

function getApiKey() {
    const date = getCurrentDate();

    return (
        date.unix + '!' + Sha1.hash('724WFSehdMRZ7FZ2meWi') + '_' + date.today
    );
}

/**
 * Check to see if we can send a vote to the API right away or wait.
 *
 * Using a browser session, check if a user has voted already. If yes, check if the current time
 * in UNIX is less than or greater than 1 seconds. If greater, no need to throttle. If less,
 * we need to throttle as per CAA business rules.
 *
 * @returns boolean
 */
function shouldThrottleVote() {
    const last_vote_time = sessionStorage.getItem('lastVotedOn');

    if (last_vote_time == null) {
        return false;
    }

    const date = getCurrentDate();
    const time_difference = date.unix - parseInt(last_vote_time);

    if (time_difference > 1) {
        return false;
    }

    return true;
}

export { submitRoadPhoto, shouldThrottleVote, getApiKey };
